const strings = {
  appName: "HRM",
  logoText: "HRM",
  login: {
    heroTitleLine1: "Hire Smarter.",
    heroTitleLine2: "Grow Faster.",
    heroSubtitle: "The corporate command center for AI-powered interviews. Orchestrate thousands of evaluations with precision and speed.",
    portalText: "CORPORATE PORTAL",
    welcomeBack: "Welcome Back",
    subtitle: "Sign in to manage your talent pipeline",
    emailPlaceholder: "Email Address",
    passwordPlaceholder: "Password",
    rememberSession: "Remember device",
    forgotPassword: "Forgot Password?",
    signInButton: "Sign In",
    newCompany: "New company?",
    registerHere: "Register here"
  },
  footer: {
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    support: "Support"
  },
  features: [
    {
      title: 'Upload & Manage Applicants',
      description: 'Easily onboard and manage applicants in bulk with a streamlined interface.',
    },
    {
      title: 'Schedule Interviews',
      description: 'Intelligent calendar coordination to schedule and manage interviews seamlessly.',
    },
    {
      title: 'AI Interview Reports',
      description: 'Review AI-evaluated interview reports and track candidate progress in real time.',
    },
    {
      title: 'Resume-JD Matching',
      description: 'Match resumes against job descriptions with AI-powered semantic analysis.',
    }
  ],
  sidebar: {
    dashboard: "Dashboard",
    learnerControl: "Applicant Directory",
    interviews: "Interviews",
    results: "Results",
    jobSearch: "Talent Search",
    portfolio: "Portfolio",
    jobPortal: "Job Portal",
    jobDashboard: "Job Dashboard",
    organizations: "Organizations",
    jobOpportunities: "Job Opportunities",
    jobApplications: "Job Applications",
    logout: "Logout"
  },
  learner: {
    pageTitle: "Applicant Control",
    addNew: "Add Applicant",
    uploadUsers: "Upload Users",
    allLearners: "All Applicants",
    searchPlaceholder: "Search by name or email",
    statusFilter: "Status",
    noRecords: "No applicants found",
    confirmDelete: "Are you sure you want to delete this applicant?",
    deleteSuccess: "Applicant deleted successfully",
    saveSuccess: "Applicant saved successfully",
    uploadSuccess: "Upload initiated successfully",
    uploadTracking: "Upload Tracking",
    downloadTemplate: "Download Template",
    uploadFile: "Upload File",
    actions: {
      view: "View",
      edit: "Edit",
      delete: "Delete"
    },
    fields: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email Address",
      contactEmail: "Contact Email",
      rollNumber: "Roll Number",
      admissionYear: "Admission Year",
      admissionNumber: "Admission Number",
      instituteName: "Institute Name",
      course: "Course",
      grade: "Grade",
      department: "Department",
      program: "Program",
      semester: "Semester",
      status: "Status",
      gender: "Gender",
      education: "Education",
      dateOfBirth: "Date of Birth",
      password: "Password",
      resumeUrl: "Resume URL",
      candidateId: "Candidate ID"
    },
    degreesList: [
      "High School Diploma",
      "CEGEP Diploma",
      "A-Levels / AS-Levels (UK)",
      "T Levels",
      "Certificate",
      "Diploma / Advanced Diploma",
      "Certificate of Higher Education",
      "Higher National Certificate (HNC)",
      "Higher National Diploma (HND)",
      "Diploma of Higher Education (DipHE)",
      "Polytechnic / Technical Diploma",
      "Professional Diplomas",
      "Higher Apprenticeships",
      "Degree Apprenticeships",
      "Associate Degree / Associate's Degree",
      "Foundation Degree",
      "Bachelor’s Degree",
      "Postgraduate Certificate / Diploma",
      "Graduate Diploma",
      "Postgraduate Certificate in Education",
      "Master’s Degree",
      "Doctor of Philosophy (PhD / DPhil)",
      "Doctor of Education (EdD)",
      "Doctor of Business Administration (DBA)",
      "Doctor of Engineering (EngD)",
      "Juris Doctor (J.D.)",
      "Doctor of Medicine (M.D.)"
    ]
  },
  interview: {
    pageTitle: "Interview Schedules",
    scheduleNew: "Schedule Interview",
    searchPlaceholder: "Search by session name...",
    upcoming: "Upcoming",
    active: "Active",
    closed: "Closed",
    noSchedules: "No interview schedules found",
    roundType: "Round Type",
    sessionName: "Session Name",
    startDateTime: "Start Date & Time",
    endDateTime: "End Date & Time",
    videoRecording: "Video Recording",
    duration: "Duration (minutes)",
    selectParticipants: "Select Participants",
    participants: "Participants",
    createSuccess: "Interview scheduled successfully",
    updateSuccess: "Interview updated successfully",
  },
  jobSearch: {
    pageTitle: "Talent Search",
    subtitle: "Search and discover applicants matching your job descriptions.",
    newSearch: "Talent Search",
    searchHistory: "Search History",
    title: "Title",
    jobDescription: "Job Description",
    topK: "Search Results",
    topKHint: "Maximum number of search results to display (10-100)",
    searchedBy: "Searched By",
    searchDate: "Search Date",
    regenerate: "Regenerate Results",
    regenerating: "Regenerating...",
    noSearches: "No talent searches found",
    resultsTitle: "Search Results",
    resultsUpToDate: "These results are up to date as of",
    matchScore: "Match Score",
    viewResume: "View Resume",
    createSuccess: "Talent search completed successfully",
    regenerateSuccess: "Talent search regenerated successfully",
    noResults: "No applicants found matching the criteria"
  },
  jobPortal: {
    organizations: "Organizations",
    createOrganization: "Create Organization",
    editOrganization: "Edit Organization",
    jobOpportunities: "Job Opportunities",
    jobApplications: "Job Applications",
    createOpportunity: "Create Job Opportunity",
    editOpportunity: "Edit Job Opportunity",
    applicants: "Applicants",
    addApplicant: "Add Applicant",
    rejectApplicant: "Reject Applicant",
    applicationStages: "Application Stages",
    rejectionReasons: "Rejection Reasons",
    dashboard: "Job Dashboard"
  }
};

export default strings;
